import { Link } from "react-router-dom";
import { Card, ColorDot, Icon, useT } from "@mmm/ui";
import { getMindMap } from "../../api/queries.js";
import { useQuery } from "../../api/useQuery.js";
import { MapDiagram } from "../maps/MapDiagram.js";

interface MapPreviewCardProps {
  title: string;
  color: string;
  mindMapId?: string;
  to: string;
}

export function MapPreviewCard({ title, color, mindMapId, to }: MapPreviewCardProps) {
  const t = useT();
  const map = useQuery(getMindMap, { mindMapId: mindMapId ?? "" }, { enabled: !!mindMapId });

  return <Card as="section" padding="none" interactive className="mmm-dashboard-panel mmm-map-preview-card">
    <Link to={to} className="mmm-map-preview-link" aria-label={t("subjects.viewMap")}>
      <header className="mmm-dashboard-panel-head">
        <div><h2>{t("nav.map")}</h2></div>
        <Icon name="map" />
      </header>
      <div className="mmm-map-preview-surface">
        {map.data?.nodes.length
          ? <MapDiagram aggregate={map.data} className="mmm-map-preview-diagram" />
          : <Card padding="sm" className="mmm-map-preview-root"><ColorDot color={color} square bordered size="sm" />{title}</Card>}
      </div>
      {Boolean(map.error) && <p className="mmm-map-preview-error">{t("maps.loadFailed")}</p>}
    </Link>
  </Card>;
}
